import { asyncRouterMap, constantRouterMap } from '@/config/router'

export default {
    state: {
        sidebar: true,
        device: 'desktop',
        theme: '',
        layout: '',
        contentWidth: '',
        fixedHeader: false,
        fixSiderbar: false,
        autoHideHeader: false,
        color: null,
        weak: false,
        multiTab: true,
        routers: constantRouterMap,
        addRouters: []
    },
    mutations: {
        setSidebar (state, type) {
            state.sidebar = type
        },
        setAppTheme (state, config) {
            state.layout = config.layout
            state.weak = config.colorWeak
            state.theme = config.navTheme
            state.multiTab = config.multiTab
            state.color = config.primaryColor
            state.fixedHeader = config.fixedHeader
            state.fixSiderbar = config.fixSiderbar
            state.contentWidth = config.contentWidth
            state.autoHideHeader = config.autoHideHeader
        },
        setAsyncRouterMap (state) {
            state.addRouters = asyncRouterMap
            state.routers = constantRouterMap.concat(asyncRouterMap)
        },
        setDeviceType (state, info) {
            state.device = info.device
            state.sidebar = info.sidebar
        },
        toggleTheme (state, theme) {
            state.theme = theme
        }
    },
    actions: {}
}
